// AOS scroll animations — only init if the library was loaded (opt-in via $useAos in config.php)
window.addEventListener("load", () => {
  if (typeof AOS !== "undefined") {
    AOS.init({ disable: "mobile" });
  }
});

// Prevent default jump on placeholder anchors
document.querySelectorAll('a[href="#"]').forEach((link) => {
  link.addEventListener("click", (e) => e.preventDefault());
});

// Smooth scroll for in-page anchor links (without changing the URL hash)
document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((link) => {
  link.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href").slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    }
  });
});

// ============================================================
//  Scroll-reveal — toggles `.in` on `.reveal` elements as they
//  enter the viewport. Tailwind arbitrary variant [&.in]: handles
//  the visible state (see $reveal in partials/main.php).
// ============================================================
(function () {
  const els = document.querySelectorAll(".reveal");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("in"));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add("in");
          io.unobserve(en.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  els.forEach((el) => io.observe(el));
})();

// ============================================================
//  Mobile menu — hamburger toggles the #navMenu dropdown.
// ============================================================
(function () {
  const burger = document.getElementById("hamburger");
  const menu = document.getElementById("navMenu");
  if (!burger || !menu) return;

  function open() {
    menu.classList.remove("hidden");
    menu.classList.add("flex");
    burger.setAttribute("aria-expanded", "true");
  }
  function close() {
    menu.classList.add("hidden");
    menu.classList.remove("flex");
    burger.setAttribute("aria-expanded", "false");
  }
  function toggle() {
    menu.classList.contains("hidden") ? open() : close();
  }

  burger.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle();
  });
  menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", close));
  document.addEventListener("click", (e) => {
    if (!menu.contains(e.target) && !burger.contains(e.target)) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
})();
